"use client";
import {
  link_default
} from "../../chunk-OO3DW6CU.js";
export {
  link_default as default
};
